import { FC } from 'react';
import InfoDetailArticle from './article';
import InfoDetailRecommend from './recommend';
import LiveChat from '../liveChat';
import { InfoCardVO } from '@domain/vo/info/infoCardVO';
import { InfoDetailVO } from '@domain/vo/info/infoDetailVO';
import classnames from 'classnames/bind';
import styles from './infoDetail.module.scss';

const cx = classnames.bind(styles);

interface InfoDetailProps {
  detailData?: InfoDetailVO;
}

const InfoDetail: FC<InfoDetailProps> = ({ detailData }) => {
  const cardList = detailData?.postCards.map((card) => new InfoCardVO(card));

  const isLiveChatAvailable = detailData?.type === 'LIVE' && detailData?.chatYn;

  if (!detailData) return null;

  return (
    <section className={cx('infoDetailArea')}>
      <div className={cx('infoDetailWrap')}>
        <InfoDetailArticle detailData={detailData} />
        {isLiveChatAvailable && <LiveChat detailData={detailData} />}
      </div>
      <InfoDetailRecommend cardList={cardList} />
    </section>
  );
};

export default InfoDetail;
